import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconTranslate';
/** Renders an SVG icon. */
const SvgTranslate = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M16 17a1 1 0 0 0-.898-.995L15 16H7a1 1 0 0 0-1 1v8l.005.102A1 1 0 0 0 7 26h8a1 1 0 0 0 1-1zm2 8a3 3 0 0 1-3 3H7a3 3 0 0 1-2.996-2.846L4 25v-8a3 3 0 0 1 3-3h8l.154.004A3 3 0 0 1 18 17zm8-10V7a1 1 0 0 0-.898-.995L25 6h-8a1 1 0 0 0-1 1v3a1 1 0 1 1-2 0V7a3 3 0 0 1 3-3h8l.154.004A3 3 0 0 1 28 7v8a3 3 0 0 1-3 3h-3a1 1 0 1 1 0-2h3a1 1 0 0 0 1-1"
      />
      <path
        fill="currentColor"
        d="M11 17a1 1 0 0 1 .948.684l2 6a1 1 0 0 1-1.896.632L11.946 24h-1.892l-.106.316a1 1 0 1 1-1.896-.632l2-6 .061-.147A1 1 0 0 1 11 17m-.28 5h.56l-.28-.839zM20 8a1 1 0 1 1 2 0v1h2a1 1 0 1 1 0 2h-1.88q.144.57.44.975c.346.475.882.855 1.682 1.055a1 1 0 1 1-.484 1.94c-1.165-.292-2.105-.885-2.757-1.743-.653.858-1.595 1.452-2.759 1.743a1 1 0 1 1-.484-1.94c.8-.2 1.338-.581 1.684-1.056q.297-.405.44-.974H18a1 1 0 1 1 0-2h2zm4 16v-.586l-.793.793a1 1 0 1 1-1.414-1.414l2.5-2.5.076-.068a1 1 0 0 1 1.338.068l2.5 2.5a1 1 0 1 1-1.414 1.414L26 23.414V24a4 4 0 0 1-4 4h-1a1 1 0 1 1 0-2h1a2 2 0 0 0 2-2M8 8v.586l.793-.793a1 1 0 1 1 1.414 1.414l-2.5 2.5-.076.068a1 1 0 0 1-1.338-.068l-2.5-2.5a1 1 0 1 1 1.414-1.414L6 8.586V8a4 4 0 0 1 4-4h1a1 1 0 1 1 0 2h-1a2 2 0 0 0-2 2"
      />
    </svg>
  );
};
SvgTranslate.displayName = displayName;
export default SvgTranslate;
